import { apis, apiHolder as api, getIn18Text } from 'api';
import { MailActions } from '@web-common/state/createStore';
import { simpleHash } from '../../../util';
import { thunkHelperFactory, reduxMessage } from '@web-common/utils/redux_utils';
import { MailListThunks } from './listThunk';
import { filterTabMap } from '../../../common/constant';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const ReducerName = 'MailReducer';
const Thunks = {};
const ReducersList = [];
const thunkHelper = thunkHelperFactory(ReducerName, Thunks, ReducersList);
thunkHelper({
    name: 'searchMail',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const { value, extraCloud } = params;
        if (value) {
            dispatch(MailListThunks.loadSearchMailList({
                startIndex: 0,
            }));
            if (extraCloud && !process.env.BUILD_ISWEB && !process.env.BUILD_ISEDM) {
                dispatch(MailListThunks.searchCloudMailListExtra({
                    startIndex: 0,
                }));
            }
        }
    },
    pending: (state, action) => {
        const { value, extraCloud } = action.meta.arg || {};
        if (value) {
            state.mailSearchKey = value;
            state.isSearchRecorded = false;
            state.scrollTop = 0;
            state.listLoading = true;
            state.searchResultObj = {};
            state.selectedSearchKeys = {};
            state.defaultSelectedSearchKeyMap = {};
            state.mailSearchFolderIds = [];
            state.searchListStateTab = 'ALL';
            state.mailTabs = filterTabMap.normal;
            state.searchingRequestId = null;
        }
        else {
            state.activeSearchMailId = {
                id: '',
                accountId: '',
            };
        }
        if (extraCloud) {
            state.extraSearchCloudMailListObj = {};
            state.extraSearchCloudMailListObjStatus = '';
        }
    },
});
thunkHelper({
    name: 'deleteAllSearchMail',
    request: async (params, thunkAPI) => {
        var _a;
        const state = thunkAPI.getState().mailReducer;
        const { dispatch } = thunkAPI;
        if (state.mailSearching == 'advanced') {
            if (state.advancedSearchParam) {
                const keyHash = simpleHash(state.advancedSearchParam);
                dispatch(MailActions.updateBatchDeleteLoadin({
                    key: keyHash,
                    value: true,
                }));
                try {
                    await mailApi.batchDeleteAdvnceSearch(state.advancedSearchParam);
                }
                catch (e) {
                    dispatch(MailActions.updateBatchDeleteLoadin({
                        key: keyHash,
                        value: false,
                    }));
                    return Promise.reject(e);
                }
                dispatch(MailActions.updateBatchDeleteLoadin({
                    key: keyHash,
                    value: false,
                }));
                return {
                    type: 'advanced',
                    hash: keyHash,
                };
            }
        }
        else {
            if (state.searchParam) {
                const isAllFolderDelete = !!((_a = state.searchParam.params) === null || _a === void 0 ? void 0 : _a.subEmails);
                const keyHash = simpleHash(state.searchParam);
                dispatch(MailActions.updateBatchDeleteLoadin({
                    key: isAllFolderDelete ? '_All_Folder_Delete' : keyHash,
                    value: true,
                }));
                try {
                    await mailApi.batchDeleteSearch(state.searchParam);
                }
                catch (e) {
                    dispatch(MailActions.updateBatchDeleteLoadin({
                        key: isAllFolderDelete ? '_All_Folder_Delete' : keyHash,
                        value: false,
                    }));
                    return Promise.reject(e);
                }
                dispatch(MailActions.updateBatchDeleteLoadin({
                    key: isAllFolderDelete ? '_All_Folder_Delete' : keyHash,
                    value: false,
                }));
                return {
                    type: 'search',
                    hash: keyHash,
                };
            }
        }
    },
    fulfilled: (state, action) => {
        const { hash, type } = action.payload;
        let keyHash = '';
        if (type === 'advanced') {
            keyHash = simpleHash(state.advancedSearchParam);
        }
        else {
            keyHash = simpleHash(state.searchParam);
        }
        if (hash == keyHash) {
            state.searchList = [];
        }
        reduxMessage.success({ content: getIn18Text('YIJIANGCIBUFENYJYDZ“YSC”WJJ') });
    },
    rejected: (state, action) => {
        reduxMessage.error({ content: getIn18Text('SHANCHUSHIBAI') });
    },
});
export const searchThunk = Thunks;
export const searchReducersList = ReducersList;
